import { hot } from 'react-hot-loader/root';
import Component from './provisioningList-redux';

export default hot(Component);
